import { gql } from 'apollo-angular';

export const removeTwoFactorAuthentication = gql`
  mutation RemoveTwoFactorAuthentication {
    removeTwoFactorAuthentication
  }
`;

export const isTwoFactorAuthenticationEnabled = gql`
  mutation IsTwoFactorAuthenticationEnabled {
    isTwoFactorAuthenticationEnabled
  }
`;

export const getTwoFactorAuthenticationSecret = gql`
  mutation GetTwoFactorAuthenticationSecret {
    twoFactorAuthenticationSecret {
      secret
      qrCode
    }
  }
`;

export const verifyTwoFactorAuthenticationCode = gql`
  mutation VerifyTwoFactorAuthenticationCode(
    $input: TwoFactorAuthenticationCodeInput!
  ) {
    verifyTwoFactorAuthenticationCode(input: $input)
  }
`;

export const addTwoFactorAuthentication = gql`
  mutation AddTwoFactorAuthentication($input: TwoFactorAuthenticationInput!) {
    addTwoFactorAuthentication(input: $input)
  }
`;

export const createThirdPartyCookie = gql`
  mutation CreateThirdPartyCookie($input: ThirdPartyCookiesInput!) {
    createThirdPartyCookie(input: $input)
  }
`;
